// Store original slide templates
const SPECIAL_OFFERS_TEMPLATES = {};
let templatesStored = false;
let isInitializing = false;
let swiperInstance = null;

// Wait for Swiper library to load (non-fatal)
function waitForSwiper(timeout = 5000) {
  return new Promise((resolve) => {
    if (typeof Swiper !== 'undefined') {
      resolve(true);
      return;
    }

    const checkInterval = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkInterval);
        resolve(true);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
      resolve(false); // silent fail
    }, timeout);
  });
}

// Helper function to wait for element to exist
function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) {
        obs.disconnect();
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      observer.disconnect();
      reject();
    }, timeout);
  });
}

// Main initialization function
async function initializeSpecialOffers() {
  if (isInitializing) return;
  isInitializing = true;
  
  try {
    // Stop if section or slider not on page
    if (!document.querySelector('[data-cart-special-section]')) return;
    if (!document.querySelector('[data-special-slider]')) return;

    // Wait for Swiper (silent)
    const swiperLoaded = await waitForSwiper();
    if (!swiperLoaded) return;

    // Wait for track element
    await waitForElement('[data-special-track]');
    
    // Store templates
    storeOriginalSlides();
    
    // Refresh offers
    await refreshSpecialOffers();
    
    // Initialize slider
    initSpecialOffersSlider();
    
    // Initialize close button
    initCloseButton();
    
    // Hide loader
    hideSpecialOffersLoading();
    
  } catch (_) {
    hideSpecialOffersLoading();
  } finally {
    isInitializing = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  showSpecialOffersLoading();
  initializeSpecialOffers();

  // Cart interaction listeners
  document.body.addEventListener('click', (e) => {
    if (
      e.target.matches('[data-remove-item], .cart__remove, .quantity__button') ||
      e.target.closest('[data-remove-item], .cart__remove, .quantity__button')
    ) {
      setTimeout(() => {
        showSpecialOffersLoading();
        refreshSpecialOffers().then(() => {
          initSpecialOffersSlider();
          initCloseButton();
          hideSpecialOffersLoading();
        });
      }, 600);
    }
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      showSpecialOffersLoading();
      refreshSpecialOffers().then(() => {
        initSpecialOffersSlider();
        initCloseButton();
        hideSpecialOffersLoading();
      });
    }, 200);
  });
  
  document.addEventListener('cart:refresh', () => {
    setTimeout(() => {
      showSpecialOffersLoading();
      refreshSpecialOffers().then(() => {
        initSpecialOffersSlider();
        initCloseButton();
        hideSpecialOffersLoading();
      });
    }, 200);
  });
  
  document.addEventListener('cart-drawer:updated', () => {
    showSpecialOffersLoading();
    refreshSpecialOffers().then(() => {
      initSpecialOffersSlider();
      initCloseButton();
      hideSpecialOffersLoading();
    });
  });

  // Add to cart handler
  document.addEventListener('click', async (e) => {
    const atcBtn = e.target.closest('.special-offer-atc-btn');
    if (!atcBtn || atcBtn.disabled || atcBtn.classList.contains('adding')) return;

    e.preventDefault();
    
    const variantId = atcBtn.dataset.variantId;
    const productTitle = atcBtn.dataset.productTitle;
    const btnText = atcBtn.querySelector('.atc-btn-text');
    const btnLoading = atcBtn.querySelector('.atc-btn-loading');

    try {
      atcBtn.classList.add('adding');
      btnText.style.display = 'none';
      btnLoading.style.display = 'inline-flex';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 2,
            properties: {
              "Total metres:": "1.0 metre",
            }
          }]
        })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const data = await response.json();

      atcBtn.classList.remove('adding');
      atcBtn.classList.add('success');
      btnText.textContent = 'ADDED!';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';

      refreshCartDrawer();

      setTimeout(() => {
        atcBtn.classList.remove('success');
        btnText.textContent = 'ADD TO CART';
      }, 1500);

    } catch (_) {
      atcBtn.classList.remove('adding');
      btnText.textContent = 'ADD TO CART';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';
    }
  });
});

// Function to initialize close button
function initCloseButton() {
  const closeButton = document.querySelector('.cart-special-offers-close');
  const specialOffersSection = document.querySelector('[data-cart-special-section]');
  if (!closeButton || !specialOffersSection) return;
  
  const newCloseButton = closeButton.cloneNode(true);
  closeButton.parentNode.replaceChild(newCloseButton, closeButton);
  
  newCloseButton.addEventListener('click', function() {
    specialOffersSection.style.opacity = '0';
    specialOffersSection.style.transition = 'opacity 0.3s ease';
    
    setTimeout(function() {
      specialOffersSection.style.display = 'none';
    }, 300);
    
    sessionStorage.setItem('specialOffersClosed', 'true');
  });
  
  if (sessionStorage.getItem('specialOffersClosed') === 'true') {
    specialOffersSection.style.display = 'none';
  }
}

function showSpecialOffersLoading() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  if (specialSection) specialSection.classList.add('loading');
}

function hideSpecialOffersLoading() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  if (specialSection) specialSection.classList.remove('loading');
}

function storeOriginalSlides() {
  if (templatesStored && Object.keys(SPECIAL_OFFERS_TEMPLATES).length > 0) return;

  const slides = document.querySelectorAll('.special-offer-slide');
  if (!slides.length) return;

  slides.forEach(slide => {
    const productId = slide.dataset.productId;
    if (productId && !SPECIAL_OFFERS_TEMPLATES[productId]) {
      SPECIAL_OFFERS_TEMPLATES[productId] = slide.cloneNode(true);
    }
  });

  templatesStored = true;
}

function refreshCartDrawer() {
  showSpecialOffersLoading();
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      fetch('/cart?view=drawer')
        .then(res => res.text())
        .then(html => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.classList.remove('is-empty');
          if (cartDrawer) {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, 'text/html');
            const newDrawerContent = newDoc.querySelector('cart-drawer');
            if (newDrawerContent) cartDrawer.innerHTML = newDrawerContent.innerHTML;
          }

          setTimeout(() => {
            refreshSpecialOffers().then(() => {
              initSpecialOffersSlider();
              initCloseButton();
              hideSpecialOffersLoading();
            });
          }, 300);
        });

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cart }));
    })
    .catch(() => hideSpecialOffersLoading());
}

function initSpecialOffersSlider() {
  if (typeof Swiper === 'undefined') return;

  const slider = document.querySelector('[data-special-slider]');
  const track = document.querySelector('[data-special-track]');
  if (!slider || !track) return;

  const slides = Array.from(track.querySelectorAll('.special-offer-slide'));
  if (slides.length === 0) return;

  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  swiperInstance = new Swiper('[data-special-slider]', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '[data-special-dots]',
      clickable: true,
    },
    speed: 400,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    effect: 'slide',
  });
}

async function refreshSpecialOffers() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  const track = document.querySelector('[data-special-track]');
  if (!specialSection || !track) return;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (cart.item_count === 0) {
      specialSection.style.display = 'none';
      return;
    }

    const cartProductIds = new Set(cart.items.map(item => item.product_id.toString()));
    track.innerHTML = '';

    Object.keys(SPECIAL_OFFERS_TEMPLATES).forEach(productId => {
      if (!cartProductIds.has(productId)) {
        const slideTemplate = SPECIAL_OFFERS_TEMPLATES[productId].cloneNode(true);
        track.appendChild(slideTemplate);
      }
    });

    const remainingSlides = track.querySelectorAll('.special-offer-slide');
    if (remainingSlides.length === 0) {
      specialSection.style.display = 'none';
    } else if (sessionStorage.getItem('specialOffersClosed') !== 'true') {
      specialSection.style.display = 'block';
      specialSection.style.opacity = '1';
    }

  } catch (_) {}
}

// Search price doubler
(function () {
  const SEARCH_INPUT_SELECTOR = '.m-form-search input[type="search"]';
  const PRICE_SELECTORS = [
    '.snize-ac-results .snize-product-tag-metre span.snize-price.money',
    '.snize-search-results-main-content .snize-product-tag-metre .snize-price-list span.snize-price.money',
    '.snize-ac-results .snize-product-tag-metre span.snize-discounted-price.money',
    '.snize-search-results-main-content .snize-product-tag-metre .snize-price-list span.snize-discounted-price.money'
    
  ];

  function updatePrices() {
    PRICE_SELECTORS.forEach(selector => {
      const prices = document.querySelectorAll(selector);
      prices.forEach(priceEl => {
        if (priceEl.dataset.doubled === 'true') return;

        const text = priceEl.textContent.trim();
        const match = text.match(/([€£$])?\s?([\d,.]+)/);
        if (!match) return;

        const currency = match[1] || '$';
        const price = parseFloat(match[2].replace(/,/g, ''));
        if (isNaN(price)) return;

        priceEl.textContent = `${currency}${(price * 2).toFixed(2)}`;
        priceEl.dataset.doubled = 'true';
      });
    });
  }

  document.addEventListener('input', function (e) {
    if (e.target.matches(SEARCH_INPUT_SELECTOR)) {
      setTimeout(updatePrices, 300);
    }
  });

  const observer = new MutationObserver(() => {
    updatePrices();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


// Cart Drawer JS
// (function() {
//   // Function to update all cart items' meter display
//   function updateAllMeterDisplays() {
//     document.querySelectorAll('.m-cart-item__info').forEach(cartItem => {
//       const qtyInput = cartItem.querySelector('.m-quantity__input');
//       const meterValueEl = cartItem.querySelector('[data-cart-item-property-value]');
//       console.log('meterValueEl', meterValueEl);
//       if (!qtyInput || !meterValueEl) return;

//       const qty = parseFloat(qtyInput.value) || 1;
//       const meters = qty * 0.5;
//       meterValueEl.textContent = `${meters.toFixed(1)} ${meters > 1 ? 'metres' : 'metre'}`;

//     });
//   }

//   // Update single item when user clicks + or -
//   function attachMeterListeners() {
//     document.querySelectorAll('.m-cart-item__info').forEach(cartItem => {
//       const minusBtn = cartItem.querySelector('.m-quantity__button[name="minus"]');
//       const plusBtn = cartItem.querySelector('.m-quantity__button[name="plus"]');
//       const qtyInput = cartItem.querySelector('.m-quantity__input');
//       if (!qtyInput) return;

//       const updateAfterChange = () => setTimeout(updateAllMeterDisplays, 1500);

//       if (plusBtn) plusBtn.addEventListener('click', updateAfterChange);
//       if (minusBtn) minusBtn.addEventListener('click', updateAfterChange);
//       qtyInput.addEventListener('change', updateAfterChange);
//     });
//   }

//   // Initial attach
//   document.addEventListener('DOMContentLoaded', function() {

//         attachMeterListeners();
//         updateAllMeterDisplays();

//   });

//   // ✅ Listen to AJAX cart updates (Minimog + most Shopify themes trigger these)
//   document.addEventListener('cart:updated', function() {

//         attachMeterListeners();
//         updateAllMeterDisplays();
//   });

//   // ✅ For safety: if your theme uses custom events like "shopify:cart:update"
//   document.addEventListener('shopify:cart:update', function() {

//         attachMeterListeners();
//         updateAllMeterDisplays();

//   });
// })();

// (function () {
//   const METER_PER_UNIT = 0.5;
//   let isUpdating = false;
//   let observer;

//   function roundToHalf(num) {
//     return Math.round(num * 2) / 2; // rounds to nearest 0.5
//   }

//   function updateAllMeterDisplays() {
//     if (isUpdating) return;
//     isUpdating = true;

//     document.querySelectorAll('.m-cart-item').forEach(cartItem => {
//       const qtyInput = cartItem.querySelector('.m-quantity__input');
//       const meterValueEl = cartItem.querySelector('[data-cart-item-property-value]');

//       if (!qtyInput) return;

//       // ✅ Calculate metres from quantity
//       let qty = parseFloat(qtyInput.value) || 1;
//       let meters = qty * METER_PER_UNIT;

//       // ✅ Enforce minimum 1 metre
//       if (meters < 1) {
//         meters = 1;
//         qty = Math.ceil(meters / METER_PER_UNIT); // adjust quantity input
//         qtyInput.value = qty;
//       }

//       // ✅ Round metres to nearest 0.5
//       meters = roundToHalf(meters);

//       // ✅ Update input value to match metre step
//       qtyInput.value = meters / METER_PER_UNIT;

//       // ✅ Update display
//       if (meterValueEl) {
//         meterValueEl.textContent = `${meters}${meters === 1 ? ' metre' : ' metres'}`;
//       }
//     });

//     isUpdating = false;
//   }

//   /** ✅ EVENT DELEGATION */
//   document.addEventListener('click', e => {
//     if (e.target.closest('.m-quantity__button')) {
//       setTimeout(updateAllMeterDisplays, 50);
//     }
//   });

//   document.addEventListener('change', e => {
//     if (e.target.matches('.m-quantity__input')) {
//       setTimeout(updateAllMeterDisplays, 50);
//     }
//   });

//   /** ✅ OBSERVER FOR AJAX CART UPDATES */
//   function initObserver() {
//     if (observer) observer.disconnect();

//     observer = new MutationObserver(mutations => {
//       const shouldUpdate = mutations.some(m =>
//         [...m.addedNodes].some(n =>
//           n.nodeType === 1 && n.classList?.contains('m-cart-item')
//         )
//       );
//       if (shouldUpdate) setTimeout(updateAllMeterDisplays, 50);
//     });

//     ['.m-cart__items', '.m-cart-drawer__items'].forEach(selector => {
//       const el = document.querySelector(selector);
//       if (el) observer.observe(el, { childList: true, subtree: true });
//     });
//   }

//   /** ✅ INITIAL */
//   document.addEventListener('DOMContentLoaded', () => {
//     updateAllMeterDisplays();
//     initObserver();
//   });

//   /** ✅ Shopify events */
//   document.addEventListener('cart:updated', updateAllMeterDisplays);
//   document.addEventListener('shopify:cart:update', updateAllMeterDisplays);

// })();



// (function () {
//   const METER_PER_UNIT = 0.5;
//   let isUpdating = false;
//   let observer;

//   function updateAllMeterDisplays() {
//     if (isUpdating) return;
//     isUpdating = true;

//     document.querySelectorAll('.m-cart-item').forEach(cartItem => {
//       const metreContainer = cartItem.querySelector('.item-tag-metre') || (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
//       if (!metreContainer) return;

//       const qtyInput = cartItem.querySelector('.m-quantity__input');
//       const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
//       if (!qtyInput || !meterValueEl) return;

//       // Parse quantity (ensure at least 1)
//       let qty = parseFloat(qtyInput.value) || 1;
//       if (qty < 1) qty = 1;

//       // Calculate total metres in increments of 0.5
//       let totalMetres = Math.max(1, qty * METER_PER_UNIT);
//       totalMetres = Math.round(totalMetres * 2) / 2; // round to nearest 0.5

//       // Update total metres text
//       const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
//       if (meterValueEl.textContent.trim() !== newText) {
//         meterValueEl.textContent = newText;
//       }

//       // Sync quantity input to totalMetres / METER_PER_UNIT (optional if you want to force increments)
//       qtyInput.value = totalMetres / METER_PER_UNIT;
//     });

//     isUpdating = false;
//   }

//   // Event delegation for plus/minus buttons
//   document.addEventListener('click', e => {
//     if (e.target.closest('.m-quantity__button')) {
//       setTimeout(updateAllMeterDisplays, 100);
//     }
//   });

//   // Event for manual quantity input
//   document.addEventListener('change', e => {
//     if (e.target.matches('.m-quantity__input')) {
//       setTimeout(updateAllMeterDisplays, 100);
//     }
//   });

//   // Observe cart changes (AJAX)
//   function initObserver() {
//     if (observer) observer.disconnect();
//     observer = new MutationObserver(mutations => {
//       const shouldUpdate = mutations.some(m =>
//         [...m.addedNodes].some(n =>
//           n.nodeType === 1 && n.classList?.contains('m-cart-item')
//         )
//       );
//       if (shouldUpdate) setTimeout(updateAllMeterDisplays, 200);
//     });

//     ['.m-cart__items', '.m-cart-drawer__items'].forEach(selector => {
//       const el = document.querySelector(selector);
//       if (el) observer.observe(el, { childList: true });
//     });
//   }

//   // Init
//   document.addEventListener('DOMContentLoaded', () => {
//     updateAllMeterDisplays();
//     initObserver();
//   });

//   document.addEventListener('cart:updated', updateAllMeterDisplays);
//   document.addEventListener('shopify:cart:update', updateAllMeterDisplays);

// })();


// (function () {
//   const METER_PER_UNIT = 0.5;
//   let isUpdating = false;
//   let observer;
//   const debounceMap = new Map();
//   const pendingUpdates = new Map();

//   function updateAllMeterDisplays() {
//     if (isUpdating) return;
//     isUpdating = true;

//     document.querySelectorAll('.m-cart-item').forEach(cartItem => {
//       // ✅ Handle both structures: nested .item-tag-metre OR direct class
//       const metreContainer = cartItem.querySelector('.item-tag-metre') || 
//                             (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
      
//       if (!metreContainer) return;

//       const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
//       const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');

//       if (!qtyInput || !meterValueEl) return;

//       const line = parseInt(qtyInput.dataset.index, 10);
//       const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

//       let totalMetres = qty * METER_PER_UNIT;
//       totalMetres = Math.max(1, Math.round(totalMetres * 2) / 2);

//       const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;

//       // Update display
//       if (meterValueEl.textContent.trim() !== newText) {
//         meterValueEl.textContent = newText;
//       }
      
//       // ✅ Store the update for this specific line
//       pendingUpdates.set(line, { quantity: qty, totalMetres: totalMetres });
//     });

//     isUpdating = false;
    
//     // ✅ Process all pending updates
//     processPendingUpdates();
//   }

//   // ✅ Process all pending updates sequentially
//   async function processPendingUpdates() {
//     if (pendingUpdates.size === 0) return;

//     const updates = Array.from(pendingUpdates.entries());
//     pendingUpdates.clear();

//     for (const [line, data] of updates) {
//       await syncCheckoutProperty(line, data.quantity, data.totalMetres);
//     }
//   }

//   // ✅ Update cart with both quantity and property
//   function syncCheckoutProperty(line, quantity, totalMetres) {
//     return new Promise((resolve) => {
//       clearTimeout(debounceMap.get(line));
      
//       debounceMap.set(
//         line,
//         setTimeout(async () => {
//           try {
//             const response = await fetch('/cart/change.js', {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 line: line,
//                 quantity: quantity,
//                 properties: {
//                   'Total Metre': `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`
//                 }
//               })
//             });
            
//             const cart = await response.json();
//             console.log(`Line ${line} updated:`, cart.items[line - 1]);
//             resolve(cart);
//           } catch (error) {
//             console.error(`Error updating line ${line}:`, error);
//             resolve(null);
//           }
//         }, 400)
//       );
//     });
//   }

//   // ✅ Handle quantity changes with proper structure detection
//   function handleQuantityChange(target) {
//     const cartItem = target.closest('.m-cart-item');
//     if (!cartItem) return;

//     // ✅ Check both structures
//     const metreContainer = cartItem.querySelector('.item-tag-metre') || 
//                           (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
    
//     if (!metreContainer) return;

//     const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
//     if (!qtyInput) return;

//     const line = parseInt(qtyInput.dataset.index, 10);
//     const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    
//     let totalMetres = qty * METER_PER_UNIT;
//     totalMetres = Math.max(1, Math.round(totalMetres * 2) / 2);

//     // Update display immediately
//     const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
//     if (meterValueEl) {
//       const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
//       meterValueEl.textContent = newText;
//     }

//     // Queue the update
//     pendingUpdates.set(line, { quantity: qty, totalMetres: totalMetres });
    
//     setTimeout(() => {
//       processPendingUpdates();
//     }, 100);
//   }

//   // Plus / minus buttons
//   document.addEventListener('click', e => {
//     const button = e.target.closest('.m-quantity__button');
//     if (button) {
//       setTimeout(() => {
//         handleQuantityChange(button);
//       }, 150);
//     }
//   });

//   // Manual input change
//   document.addEventListener('change', e => {
//     if (e.target.matches('.m-quantity__input')) {
//       handleQuantityChange(e.target);
//     }
//   });

//   // ✅ Real-time display update while typing
//   document.addEventListener('input', e => {
//     if (e.target.matches('.m-quantity__input')) {
//       const cartItem = e.target.closest('.m-cart-item');
//       if (!cartItem) return;

//       const metreContainer = cartItem.querySelector('.item-tag-metre') || 
//                             (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
      
//       if (!metreContainer) return;

//       const qty = Math.max(1, parseInt(e.target.value, 10) || 1);
//       let totalMetres = qty * METER_PER_UNIT;
//       totalMetres = Math.max(1, Math.round(totalMetres * 2) / 2);
      
//       const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
//       if (meterValueEl) {
//         const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
//         meterValueEl.textContent = newText;
//       }
//     }
//   });

//   // Observe drawer + cart page
//   function initObserver() {
//     if (observer) observer.disconnect();

//     observer = new MutationObserver(mutations => {
//       const shouldUpdate = mutations.some(m =>
//         [...m.addedNodes].some(n =>
//           n.nodeType === 1 && n.classList?.contains('m-cart-item')
//         )
//       );
//       if (shouldUpdate) setTimeout(updateAllMeterDisplays, 200);
//     });

//     ['.m-cart__items', '.m-cart-drawer__items'].forEach(sel => {
//       const el = document.querySelector(sel);
//       if (el) observer.observe(el, { childList: true });
//     });
//   }

//   document.addEventListener('DOMContentLoaded', () => {
//     updateAllMeterDisplays();
//     initObserver();
//   });

//   document.addEventListener('cart:updated', updateAllMeterDisplays);
//   document.addEventListener('shopify:cart:update', updateAllMeterDisplays);
// })();


(function () {
  const METER_PER_UNIT = 0.5;
  let isUpdating = false;
  let observer;
  let updateQueue = [];
  let isProcessingQueue = false;

  function updateAllMeterDisplays() {
    if (isUpdating) return;
    isUpdating = true;

    document.querySelectorAll('.m-cart-item').forEach(cartItem => {
      // ✅ Handle both structures: nested .item-tag-metre OR direct class
      const metreContainer = cartItem.querySelector('.item-tag-metre') || 
                            (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
      
      if (!metreContainer) return;

      const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
      const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');

      if (!qtyInput || !meterValueEl) return;

      const line = parseInt(qtyInput.dataset.index, 10);
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

      let totalMetres = qty * METER_PER_UNIT;
      totalMetres = Math.max(1, Math.round(totalMetres * 2) / 2);

      const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;

      // Update display
      if (meterValueEl.textContent.trim() !== newText) {
        meterValueEl.textContent = newText;
      }
      
      // ✅ Add to queue instead of immediate update
      addToQueue(line, qty, totalMetres);
    });

    isUpdating = false;
  }

  // ✅ Add update to queue (avoid duplicates for same line)
  function addToQueue(line, quantity, totalMetres) {
    // Remove existing update for this line
    updateQueue = updateQueue.filter(item => item.line !== line);
    
    // Add new update
    updateQueue.push({ line, quantity, totalMetres });
    
    // Start processing if not already running
    if (!isProcessingQueue) {
      processQueue();
    }
  }

  // ✅ Process queue one at a time with delays
  async function processQueue() {
    if (isProcessingQueue || updateQueue.length === 0) return;
    
    isProcessingQueue = true;

    while (updateQueue.length > 0) {
      const update = updateQueue.shift();
      await syncCheckoutProperty(update.line, update.quantity, update.totalMetres);
      
      // ✅ Wait between updates to avoid conflicts
      if (updateQueue.length > 0) {
        await sleep(500); // 500ms delay between each cart update
      }
    }

    isProcessingQueue = false;
  }

  // ✅ Helper function for delays
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // ✅ Update cart with both quantity and property
  async function syncCheckoutProperty(line, quantity, totalMetres) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          properties: {
            'Total Metre': `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`
          }
        })
      });
      
      const cart = await response.json();
      console.log(`✅ Line ${line} updated: ${quantity} units = ${totalMetres} metres`);
      return cart;
    } catch (error) {
      console.error(`❌ Error updating line ${line}:`, error);
      return null;
    }
  }

  // ✅ Handle quantity changes
  function handleQuantityChange(target) {
    const cartItem = target.closest('.m-cart-item');
    if (!cartItem) return;

    // ✅ Check both structures
    const metreContainer = cartItem.querySelector('.item-tag-metre') || 
                          (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
    
    if (!metreContainer) return;

    const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
    if (!qtyInput) return;

    const line = parseInt(qtyInput.dataset.index, 10);
    const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    
    let totalMetres = qty * METER_PER_UNIT;
    totalMetres = Math.max(1, Math.round(totalMetres * 2) / 2);

    // Update display immediately
    const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
    if (meterValueEl) {
      const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
      meterValueEl.textContent = newText;
    }

    // ✅ Add to queue for processing
    addToQueue(line, qty, totalMetres);
  }

  // Plus / minus buttons
  document.addEventListener('click', e => {
    const button = e.target.closest('.m-quantity__button');
    if (button) {
      setTimeout(() => {
        handleQuantityChange(button);
      }, 150);
    }
  });

  // Manual input change
  document.addEventListener('change', e => {
    if (e.target.matches('.m-quantity__input')) {
      handleQuantityChange(e.target);
    }
  });

  // ✅ Real-time display update while typing
  document.addEventListener('input', e => {
    if (e.target.matches('.m-quantity__input')) {
      const cartItem = e.target.closest('.m-cart-item');
      if (!cartItem) return;

      const metreContainer = cartItem.querySelector('.item-tag-metre') || 
                            (cartItem.classList.contains('item-tag-metre') ? cartItem : null);
      
      if (!metreContainer) return;

      const qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      let totalMetres = qty * METER_PER_UNIT;
      totalMetres = Math.max(1, Math.round(totalMetres * 2) / 2);
      
      const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
      if (meterValueEl) {
        const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
        meterValueEl.textContent = newText;
      }
    }
  });

  // Observe drawer + cart page
  function initObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(mutations => {
      const shouldUpdate = mutations.some(m =>
        [...m.addedNodes].some(n =>
          n.nodeType === 1 && n.classList?.contains('m-cart-item')
        )
      );
      if (shouldUpdate) setTimeout(updateAllMeterDisplays, 200);
    });

    ['.m-cart__items', '.m-cart-drawer__items'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateAllMeterDisplays();
    initObserver();
  });

  document.addEventListener('cart:updated', updateAllMeterDisplays);
  document.addEventListener('shopify:cart:update', updateAllMeterDisplays);
})();



// Cart Custom Error
(function () {
  // Select both cart page and cart drawer containers
  const cartContainers = document.querySelectorAll(
    '.m-cart__items, .m-cart-drawer__items'
  );

  if (!cartContainers.length) return;

  cartContainers.forEach(container => {
    container.querySelectorAll('.m-quantity__input').forEach(input => {

      // Prevent duplicate listeners
      if (input.dataset.decimalCheckAttached) return;
      input.dataset.decimalCheckAttached = 'true';

      input.addEventListener('input', function () {
        if (this.value.includes('.')) {
          this.value = Math.floor(this.value);
          showMessage(this, 'Incorrect Measurement/Quantity. Whole Numbers Only.');
        }
      });
    });
  });

  // ✅ Message function (input-specific)
  function showMessage(inputEl, text) {
    let msgBox = inputEl.closest('.m-quantity')?.querySelector('.quantity-error-msg');

    if (!msgBox) {
      msgBox = document.createElement('div');
      msgBox.className = 'quantity-error-msg';
      msgBox.style.position = 'absolute';
      msgBox.style.bottom = '0';
      msgBox.style.left = '-34px';
      msgBox.style.backgroundColor = '#fff';
      msgBox.style.color = 'red';
      msgBox.style.fontSize = '12px';
      msgBox.style.marginTop = '6px';
      msgBox.style.fontWeight = '500';
      msgBox.style.textAlign = 'center';

      inputEl.closest('.m-quantity')?.appendChild(msgBox);
    }

    msgBox.textContent = text;
    msgBox.style.display = 'block';

    setTimeout(() => {
      msgBox.style.display = 'none';
      msgBox.textContent = '';
    }, 2000);
  }
})();




// min quantity 1 on cart page and cart drawer

document.addEventListener('DOMContentLoaded', () => {
  function enforceMetreMinQuantity() {
    // Select all cart drawer and cart page items with the tag-metre class
    const metreItems = document.querySelectorAll('.m-cart-item.item-tag-metre, .m-cart__column .item-tag-metre');

    metreItems.forEach(item => {
      const input = item.querySelector('.m-quantity__input');
      if (!input) return;

      // Only update if current value is less than 2
      if (parseInt(input.value) < 2 || isNaN(parseInt(input.value))) {
        input.value = 2;
      }

      // Set min attribute to 2 (won't block higher numbers)
      input.min = 2;
    });
  }

  // Initial enforcement
  enforceMetreMinQuantity();

  // Observe changes in cart (like AJAX updates)
  const observer = new MutationObserver(() => {
    enforceMetreMinQuantity();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



// Sample Product
// (function () {
//   // ✅ Configuration
//   const EXCLUDED_PRODUCTS = ['/products/samples'];
  
//   // ✅ Exact property names to remove from checkout
//   const PROPERTIES_TO_REMOVE = [
//     'Sample of tag',
//     'Vendor',
//     'Sample of tag: Metre',
//     'Total metres',
//     'Total Metre'
//   ];

//   // ✅ Property class names to hide in cart UI
//   const PROPERTY_CLASSES_TO_HIDE = [
//     '.cart-item-total-metres',
//     '.m-cart-item__option' // This is for "Sample of tag: Metre"
//   ];

//   // ✅ Check if product should be excluded
//   function isExcludedProduct(cartItem) {
//     const productLink = cartItem.querySelector('a[href*="/products/"]');
//     if (productLink) {
//       const href = productLink.getAttribute('href');
//       return EXCLUDED_PRODUCTS.some(url => href.includes(url));
//     }
    
//     const productUrl = cartItem.dataset.productUrl || cartItem.dataset.url;
//     if (productUrl) {
//       return EXCLUDED_PRODUCTS.some(url => productUrl.includes(url));
//     }
    
//     return false;
//   }

//   // ✅ Hide excluded properties from display in cart
//   function hideExcludedProperties(cartItem) {
//     // Hide by specific class names
//     PROPERTY_CLASSES_TO_HIDE.forEach(className => {
//       const elements = cartItem.querySelectorAll(className);
//       elements.forEach(el => {
//         el.style.display = 'none';
//       });
//     });

//     // Hide "Sample of tag" option
//     const options = cartItem.querySelectorAll('.m-cart-item__option');
//     options.forEach(el => {
//       if (el.textContent.includes('Sample of tag')) {
//         el.style.display = 'none';
//       }
//     });

//     // Hide the metre tag container if it exists
//     const metreContainer = cartItem.querySelector('.item-tag-metre');
//     if (metreContainer) {
//       metreContainer.style.display = 'none';
//     }
//     // Hide the metre tag container if it exists
//     const vendorContainer = cartItem.querySelector('.cart-item-vendor');
//     if (vendorContainer) {
//       vendorContainer.style.display = 'none';
//     }
//   }

//   // ✅ Get current cart and filter properties
//   async function removePropertiesFromCart(line) {
//     try {
//       // First, get the current cart to see existing properties
//       const cartResponse = await fetch('/cart.js');
//       const cart = await cartResponse.json();
      
//       // Find the item by line number (line is 1-indexed)
//       const item = cart.items[line - 1];
//       if (!item) {
//         console.log('❌ Item not found at line', line);
//         return;
//       }

//       // Get current properties
//       const currentProperties = item.properties || {};
      
//       console.log('📋 Current properties for line', line, ':', currentProperties);
      
//       // Create new properties object, keeping only the ones we want
//       const newProperties = {};
//       Object.keys(currentProperties).forEach(key => {
//         // Check if this exact property should be removed
//         const shouldRemove = PROPERTIES_TO_REMOVE.some(prop => key === prop);
        
//         if (!shouldRemove) {
//           newProperties[key] = currentProperties[key];
//           console.log('✅ Keeping property:', key, '=', currentProperties[key]);
//         } else {
//           console.log('❌ Removing property:', key);
//         }
//       });

//       console.log('📦 New properties to save:', newProperties);

//       // Update cart with filtered properties
//       const response = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           line: line,
//           quantity: item.quantity,
//           properties: newProperties
//         })
//       });
      
//       const updatedCart = await response.json();
//       console.log(`✅ Updated cart for line ${line}`);
//       console.log('Final properties at checkout:', updatedCart.items[line - 1].properties);
//       return updatedCart;
//     } catch (error) {
//       console.error(`❌ Error filtering properties:`, error);
//       return null;
//     }
//   }

//   // ✅ Process all cart items
//   async function processCartItems() {
//     console.log('🔄 Processing cart items...');
//     const cartItems = document.querySelectorAll('.m-cart-item');
    
//     for (const cartItem of cartItems) {
//       if (isExcludedProduct(cartItem)) {
//         console.log('🎯 Found samples product, processing...');
        
//         // Hide properties in UI immediately
//         hideExcludedProperties(cartItem);
        
//         // Remove from cart/checkout
//         const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
//         if (qtyInput) {
//           const line = parseInt(qtyInput.dataset.index, 10);
//           if (line) {
//             await removePropertiesFromCart(line);
//             // Wait before processing next item
//             await new Promise(resolve => setTimeout(resolve, 400));
//           }
//         }
//       }
//     }
//   }

//   // ✅ Observe cart changes
//   let observer;
//   function initObserver() {
//     if (observer) observer.disconnect();

//     observer = new MutationObserver(() => {
//       setTimeout(processCartItems, 500);
//     });

//     ['.m-cart__items', '.m-cart-drawer__items', '.m-cart-drawer-item__variant'].forEach(sel => {
//       const el = document.querySelector(sel);
//       if (el) observer.observe(el, { childList: true, subtree: true });
//     });
//   }

//   // ✅ Initialize
//   document.addEventListener('DOMContentLoaded', () => {
//     setTimeout(processCartItems, 800);
//     initObserver();
//   });

//   document.addEventListener('cart:updated', () => {
//     setTimeout(processCartItems, 500);
//   });
  
//   document.addEventListener('shopify:cart:update', () => {
//     setTimeout(processCartItems, 500);
//   });

//   // ✅ Also run when cart drawer opens
//   document.addEventListener('click', (e) => {
//     if (e.target.closest('[data-cart-drawer-toggle], .m-cart-drawer-toggle')) {
//       setTimeout(processCartItems, 600);
//     }
//   });

//   // ✅ DEBUG: Check cart properties
//   window.debugSamplesCart = async function() {
//     const cart = await fetch('/cart.js').then(r => r.json());
//     console.log('🛒 Full cart:', cart);
//     cart.items.forEach((item, index) => {
//       console.log(`Item ${index + 1}:`, item.product_title);
//       console.log('Properties:', item.properties);
//     });
//   };
  
//   console.log('💡 Run debugSamplesCart() in console to see current cart properties');
// })();





// (function () {
//   const sampleBtn = document.querySelector('.product-samples-button');
//   const productForm = document.querySelector('form[action="/cart/add"]');
//   if (!sampleBtn || !productForm) return;

//   const RETRY_DELAY = 300;
//   const MAX_RETRIES = 10;
//   let retries = 0;

//   function getVariantInput() {
//     return productForm.querySelector('input[name="id"]');
//   }

//   function updateSampleVariant() {
//     const variantInput = getVariantInput();
//     const variantId = variantInput?.value;

//     if (!variantId) {
//       if (retries < MAX_RETRIES) {
//         retries++;
//         setTimeout(updateSampleVariant, RETRY_DELAY);
//       }
//       return;
//     }

//     sampleBtn.setAttribute('data-sample-variant', variantId);
//   }

//   /* ---------- Initial load (delayed) ---------- */
//   document.addEventListener('DOMContentLoaded', () => {
//     setTimeout(updateSampleVariant, 400);
//   });

//   /* ---------- Observe variant changes ---------- */
//   const observer = new MutationObserver(() => {
//     retries = 0;
//     setTimeout(updateSampleVariant, 100);
//   });

//   const variantInput = getVariantInput();
//   if (variantInput) {
//     observer.observe(variantInput, {
//       attributes: true,
//       attributeFilter: ['value']
//     });
//   }

// })();



// Sample Product - Remove properties and variant option
(function () {
  // ✅ Configuration
  const EXCLUDED_PRODUCTS = ['/products/samples'];
  
  // ✅ Exact property names to remove from checkout
  const PROPERTIES_TO_REMOVE = [
    'Sample of tag',
    'Vendor',
    'Sample of tag: Metre',
    'Total metres',
    'Total Metre'
  ];

  // ✅ Property class names to hide in cart UI
  const PROPERTY_CLASSES_TO_HIDE = [
    '.cart-item-total-metres',
    '.m-cart-item__option' // This is for "Sample of tag: Metre" and variant options
  ];

  // ✅ Check if product should be excluded
  function isExcludedProduct(cartItem) {
    const productLink = cartItem.querySelector('a[href*="/products/"]');
    if (productLink) {
      const href = productLink.getAttribute('href');
      return EXCLUDED_PRODUCTS.some(url => href.includes(url));
    }
    
    const productUrl = cartItem.dataset.productUrl || cartItem.dataset.url;
    if (productUrl) {
      return EXCLUDED_PRODUCTS.some(url => productUrl.includes(url));
    }
    
    return false;
  }

  // ✅ Hide excluded properties and variant options from display in cart
  function hideExcludedProperties(cartItem) {
    // Hide by specific class names
    PROPERTY_CLASSES_TO_HIDE.forEach(className => {
      const elements = cartItem.querySelectorAll(className);
      elements.forEach(el => {
        el.style.display = 'none';
      });
    });

    // Hide ALL variant options (Title, Size, Color options, etc.)
    const options = cartItem.querySelectorAll('.m-cart-item__option');
    options.forEach(el => {
      el.style.display = 'none';
    });

    // Hide the metre tag container if it exists
    const metreContainer = cartItem.querySelector('.item-tag-metre');
    if (metreContainer) {
      metreContainer.style.display = 'none';
    }
    
    // Hide the vendor container if it exists
    const vendorContainer = cartItem.querySelector('.cart-item-vendor');
    if (vendorContainer) {
      vendorContainer.style.display = 'none';
    }
  }

  // ✅ Get current cart and filter properties
  async function removePropertiesFromCart(line) {
    try {
      // First, get the current cart to see existing properties
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item by line number (line is 1-indexed)
      const item = cart.items[line - 1];
      if (!item) {
        console.log('❌ Item not found at line', line);
        return;
      }

      // Get current properties
      const currentProperties = item.properties || {};
      
      console.log('📋 Current properties for line', line, ':', currentProperties);
      
      // Create new properties object, keeping only the ones we want
      const newProperties = {};
      Object.keys(currentProperties).forEach(key => {
        // Check if this exact property should be removed
        const shouldRemove = PROPERTIES_TO_REMOVE.some(prop => key === prop);
        
        if (!shouldRemove) {
          newProperties[key] = currentProperties[key];
          console.log('✅ Keeping property:', key, '=', currentProperties[key]);
        } else {
          console.log('❌ Removing property:', key);
        }
      });

      console.log('📦 New properties to save:', newProperties);

      // Update cart with filtered properties
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: item.quantity,
          properties: newProperties
        })
      });
      
      const updatedCart = await response.json();
      console.log(`✅ Updated cart for line ${line}`);
      console.log('Final properties at checkout:', updatedCart.items[line - 1].properties);
      return updatedCart;
    } catch (error) {
      console.error(`❌ Error filtering properties:`, error);
      return null;
    }
  }

  // ✅ Process all cart items
  async function processCartItems() {
    console.log('🔄 Processing cart items...');
    const cartItems = document.querySelectorAll('.m-cart-item');
    
    for (const cartItem of cartItems) {
      if (isExcludedProduct(cartItem)) {
        console.log('🎯 Found samples product, processing...');
        
        // Hide properties and variant options in UI immediately
        hideExcludedProperties(cartItem);
        
        // Remove from cart/checkout
        const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
        if (qtyInput) {
          const line = parseInt(qtyInput.dataset.index, 10);
          if (line) {
            await removePropertiesFromCart(line);
            // Wait before processing next item
            await new Promise(resolve => setTimeout(resolve, 400));
          }
        }
      }
    }
  }

  // ✅ Observe cart changes
  let observer;
  function initObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(() => {
      setTimeout(processCartItems, 500);
    });

    ['.m-cart__items', '.m-cart-drawer__items', '.m-cart-drawer-item__variant'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  // ✅ Initialize
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(processCartItems, 800);
    initObserver();
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(processCartItems, 500);
  });
  
  document.addEventListener('shopify:cart:update', () => {
    setTimeout(processCartItems, 500);
  });

  // ✅ Also run when cart drawer opens
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-toggle], .m-cart-drawer-toggle')) {
      setTimeout(processCartItems, 600);
    }
  });

  // ✅ DEBUG: Check cart properties
  window.debugSamplesCart = async function() {
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('🛒 Full cart:', cart);
    cart.items.forEach((item, index) => {
      console.log(`Item ${index + 1}:`, item.product_title);
      console.log('Variant title:', item.variant_title);
      console.log('Properties:', item.properties);
    });
  };
  
  console.log('💡 Run debugSamplesCart() in console to see current cart properties');
})();
